import { render, staticRenderFns } from "./Banners.vue?vue&type=template&id=ce910156&scoped=true&"
import script from "./Banners.vue?vue&type=script&async=true&lang=js&"
export * from "./Banners.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Banners.vue?vue&type=style&index=0&id=ce910156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce910156",
  null
  
)

export default component.exports